import styled, { css } from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'
import Typography, { FontWeights } from 'builder/styles/typography'
import { gradient } from 'builder/styles/keyframes'

const animationCss = css`
  background: linear-gradient(
    to right,
    ${Colors.Neutral5} 5%,
    #eaeef6 15%,
    ${Colors.Neutral10} 25%
  );
  background-size: 100vw 100vh;
  animation: ${gradient} 1s linear infinite;
`

export const ProcessingContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 0 32px;

  ${Media.Phone`
    gap: 12px;
    padding: 0 24px;
    min-height: 234px;
    max-height: 234px;
  `}
`

export const ProcessingTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const ProcessingHeader = styled.h2`
  ${Typography.S};
  ${FontWeights.Medium};

  text-align: center;
  color: ${Colors.Neutral90};
`

export const ProcessingDescription = styled.p`
  ${Typography.Body}
  ${FontWeights.Regular}
  
  text-align: center;
  color: ${Colors.Neutral50};
`

export const SkeletonContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`

export const SkeletonImageContainer = styled.div`
  width: 100%;
  height: 100%;
  margin-top: -20px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${Media.Phone`
    margin-top: 24px;
  `};
`

export const SkeletonImage = styled.div`
  height: 270px;
  width: 201px;
  ${animationCss}

  ${Media.Tablet`
    width: 166px;
  `};

  ${Media.Phone`
    width: 130px;
    height: 180px;
  `};
`

export const SkeletonInfo = styled.div`
  position: absolute;
  bottom: 75px;
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: var(--Spacing-S, 16px);
  background: ${Colors.White};

  ${Media.Phone`
    bottom: 0;
  `};
`

export const SkeletonHeader = styled.div`
  height: 44px;
  width: 248px;
  ${animationCss}

  ${Media.Phone`
    height: 34px;
  `};
`

export const SkeletonDescription = styled.div`
  width: 145px;
  height: 24px;
  ${animationCss}
`

export const SkeletonFadeResume = styled.div`
  position: absolute;
  width: 250px;
  height: 88px;
  margin-top: 22px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 100%);
  z-index: 3;
  left: 50%;
  transform: translateX(-50%);

  ${Media.Phone`
    height: 50px;
    margin-top: -15px;
  `};
`
